module.exports = __webpack_public_path__ + "static/media/logo-mr.0fd6c2e7.svg";